import { ArrowRightOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Button, Empty, Flex } from 'antd'
import { useTheme } from 'antd-style'

import {
  useUserServiceGetMessagesCountEndpointKey,
  useUserServiceGetMessagesListEndpointKey,
  useUserServiceMessagesMarkReadAllEndpoint
} from 'src/api/queries'
import { GetMessagesListResponseItem } from 'src/api/requests'
import { CheckIcon } from 'src/assets'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { NotificationPopoverCard } from './NotificationPopoverCard'
import { useStyles } from './styles'

type Props = {
  notificationsCount?: number
  notifications?: GetMessagesListResponseItem[]
}

export const NotificationsContent = ({
  notificationsCount,
  notifications
}: Props) => {
  const { styles } = useStyles()
  const { t } = useLocales()
  const palette = useTheme()

  const queryClient = useQueryClient()

  const { mutate } = useUserServiceMessagesMarkReadAllEndpoint({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useUserServiceGetMessagesCountEndpointKey]
      })
      queryClient.invalidateQueries({
        queryKey: [useUserServiceGetMessagesListEndpointKey]
      })
    }
  })

  return (
    <Flex vertical className={styles.wrapper}>
      <Flex justify="space-between" align="center" className={styles.header}>
        <Text size="md" color={palette.grey.grey1}>
          {t('notifications.title')}{' '}
          {notificationsCount && `(${notificationsCount})`}
        </Text>

        <Flex
          className={styles.readAll}
          align="center"
          gap={4}
          onClick={() => mutate()}
        >
          <CheckIcon />
          <Text>{t('notifications.read_all')}</Text>
        </Flex>
      </Flex>

      {!notifications?.length && (
        <Empty
          className={styles.emptyNotifications}
          description={t('notifications.empty_text')}
        />
      )}

      {notifications?.map((notification) => (
        <NotificationPopoverCard key={notification.id} {...notification} />
      ))}

      <Flex justify="center">
        <Button
          href="/notifications"
          type="link"
          icon={<ArrowRightOutlined />}
          iconPosition="end"
        >
          <Text>{t('notifications.see_all')}</Text>
        </Button>
      </Flex>
    </Flex>
  )
}
